export default __webpack_public_path__ + "static/media/Mystic's Boots of the Purple Sun.38cef253.jpg";